import { AppThunk } from 'app/store'

import * as api from 'services/rfp'
import { parseError } from 'utils/errors'
import { slice } from './reducer'
import { AlertMessage } from 'features/message/reducer'
import { showMessage } from 'features/message/actions'

export const {
  fetchRFPListStart,
  fetchRFPListSuccess,
  fetchRFPListFailed,
  fetchRFPDetailStart,
  fetchRFPDetailSuccess,
  fetchRFPDetailFailed,
  updateRFPDetailStart,
  updateRFPDetailSuccess,
  updateRFPDetailFailed,
  updateRFPItemStart,
  updateRFPItemSuccess,
  updateRFPItemFailed,
  deleteRFPItemSuccess,
  updateRFPDetailLaneProposal,
  setRFPDetailExporting,
  setRFPDetailError,
} = slice.actions

export const fetchRFPList = (state: string): AppThunk => async (dispatch) => {
  dispatch(fetchRFPListStart(state))
  try {
    const data = await api.list({ state })
    dispatch(fetchRFPListSuccess(data))
  } catch (err) {
    dispatch(fetchRFPListFailed(parseError(err)))
  }
}

export const fetchRFPById = (id: string | number): AppThunk => async (
  dispatch
) => {
  dispatch(fetchRFPDetailStart())
  try {
    const data = await api.retrieve(id)
    dispatch(fetchRFPDetailSuccess(data))
  } catch (err) {
    dispatch(fetchRFPDetailFailed(parseError(err)))
  }
}

export const partialUpdateRFP = (
  id: number,
  payload: Partial<RequestForProposal>,
  successMessage?: Omit<AlertMessage, 'id'>
): AppThunk => async (dispatch) => {
  dispatch(updateRFPDetailStart())
  try {
    const data = await api.partialUpdate(id, payload)
    dispatch(updateRFPDetailSuccess(data))
    if (successMessage) {
      dispatch(showMessage(successMessage))
    }
  } catch (err) {
    dispatch(updateRFPDetailFailed(parseError(err)))
  }
}
export const partialUpdateRFPItem = (
  id: number,
  payload: Partial<RequestForProposal>
): AppThunk => async (dispatch) => {
  dispatch(updateRFPItemStart(id))
  try {
    const data = await api.partialUpdate(id, payload)
    dispatch(updateRFPItemSuccess(data))
  } catch (err) {
    const error = parseError(err)
    dispatch(updateRFPItemFailed({ id, error }))
  }
}

export const deleteRFPById = (id: number): AppThunk => async (dispatch) => {
  dispatch(updateRFPItemStart(id))
  try {
    await api.remove(id)
    dispatch(deleteRFPItemSuccess(id))
  } catch (err) {
    const error = parseError(err)
    dispatch(updateRFPItemFailed({ id, error }))
  }
}

export const downloadAwardedCarriers = (
  rfp: RequestForProposalDetail
): AppThunk => async (dispatch) => {
  dispatch(setRFPDetailExporting(true))
  try {
    const data = await api.exportAwardedCarriers(rfp.id)
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([data]))
    link.setAttribute('download', `${rfp.name} Awards.csv`)

    document.body.append(link)
    link.click()
    dispatch(setRFPDetailExporting(false))
    link.remove()
  } catch (err) {
    const error = parseError(err)
    setRFPDetailError(error)
  }
}
